import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import { Send } from '@mui/icons-material';
import { scoutService } from '../../services/scoutService';

interface Message {
  id: number;
  direction: 'company_to_athlete' | 'athlete_to_company';
  body: string;
  createdAt: string;
}

interface Props {
  threadId: string;
  messages: Message[];
  role: 'athlete' | 'company';
  disabled?: boolean;
  onMessageSent: () => void;
}

const ScoutThreadView: React.FC<Props> = ({ threadId, messages, role, disabled, onMessageSent }) => {
  const [reply, setReply] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!reply.trim()) return;
    setSending(true);
    try {
      await scoutService.reply(threadId, reply);
      setReply('');
      onMessageSent();
    } catch (err) {
      console.error('Reply failed:', err);
    } finally {
      setSending(false);
    }
  };

  const isOwn = (direction: string) => {
    return (role === 'athlete' && direction === 'athlete_to_company') ||
           (role === 'company' && direction === 'company_to_athlete');
  };

  return (
    <Box>
      {/* メッセージ一覧 */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
        {messages.map((msg) => (
          <Box key={msg.id} sx={{ display: 'flex', justifyContent: isOwn(msg.direction) ? 'flex-end' : 'flex-start' }}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                maxWidth: '70%',
                bgcolor: isOwn(msg.direction) ? '#e3f2fd' : '#f5f5f5',
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.8 }}>
                {msg.body}
              </Typography>
              <Typography variant="caption" sx={{ color: '#999', mt: 1, display: 'block' }}>
                {new Date(msg.createdAt).toLocaleString('ja-JP')}
              </Typography>
            </Paper>
          </Box>
        ))}
      </Box>

      {/* 返信入力 */}
      {!disabled && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            fullWidth
            multiline
            rows={2}
            placeholder="メッセージを入力..."
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            size="small"
          />
          <Button
            variant="contained"
            onClick={handleSend}
            disabled={sending || !reply.trim()}
            sx={{ minWidth: 100 }}
            startIcon={<Send />}
          >
            送信
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ScoutThreadView;
